/**
 * Created by Ivan on 04/06/2017.
 */
let component = {
    props : ['contacto'],
    created : function(){
        var self = this;
        this.unsubscribe  = this.$store.subscribe((mutation,state) => {
            self.$language = self.$store.state.language;
        });
    },
    beforeDestroy : function(){
        this.unsubscribe();
    },
    methods : {
        tr : function(t){
            return this.translate( this.$language, t);
        },
        send : function(){
            let self = this;
            this.contacto.send().then(function(){
                self.$swal(self.tr( 'done_contact'), self.tr( 'done_contact_message'),'success');
            }, function(err){
                console.error(err);
            });
        }
    },
    computed : {
        valid : function(){
            return this.contacto.valid();
        }
    }
};

export default component;


// WEBPACK FOOTER //
// ./src/components/contactForm/index.js